export interface MinimalProfile {
  first_name: string;
  last_name: string;
  picture_url?: string | null;
}

export function getInitials(profile?: MinimalProfile) {
  if (
    !profile ||
    (profile.first_name.length < 1 && profile.last_name.length < 1) // No first and last name
  )
    return '';

  // There is either a first name or a last name (or both)
  if (profile.first_name.length > 0 && profile.last_name.length > 0) {
    return `${profile.first_name.charAt(0)}${profile.last_name.charAt(0)}`.toUpperCase();
  }

  // There is only one - either first or last name
  const name =
    profile.first_name.length > 0 ? profile.first_name : profile.last_name;
  return name.substring(0, 2).toUpperCase();
}

export function getFullName(profile?: MinimalProfile) {
  if (!profile) return '';
  return `${profile.first_name} ${profile.last_name}`.trim();
}

/**
 * Splits a full name into first name and last name. The first name is the first
 * word, the last name is everything else.
 */
export function splitFullName(fullName: string) {
  const parts = fullName.split(' ');
  const cleanParts = parts
    .map((part) => part.trim())
    .filter((part) => part.length > 0);

  const firstName = cleanParts.shift() ?? '';
  const lastName = cleanParts.join(' ');
  return { firstName, lastName };
}
